import React, {useCallback} from "react"
import Timeline from "./Timeline"
import ResultsIndicator from "./ResultsIndicator";
import {Element, scroller} from "react-scroll";
import {stepScroll} from "../../helpers";

export default function Progress(){

    const onScrollToAnchor = useCallback((name: 'timeline' | 'results') => {
        scroller.scrollTo(name, {...stepScroll, offset: 0})
    }, [])

    return (
        <div>
            <Timeline onScroll={onScrollToAnchor}/>
            <Element name="results">
                <ResultsIndicator/>
            </Element>
        </div>
    )
}
